module.exports = __webpack_public_path__ + "img/scuba_900.137cecb9.png";